// The "Other Tournaments" folder in the sidebar (#nav-group-others).
//
// Arbiters have many tabs, so Ongoing / Upcoming / Finished Tournaments sit in a
// folder they open and close. Players and guests have few tabs, and for them the
// three lists ARE the app, so the group is flat: no folder row, tabs always shown.
//
// Open or closed is a per-device convenience kept in localStorage. Arriving at one
// of the three views (a link, Back, a reload) opens the folder so the highlighted
// tab is in sight; closing it while on one of them leaves the folder row
// highlighted instead.

const group = document.getElementById('nav-group-others');
const toggleBtn = group ? group.querySelector('.nav-group-toggle') : null;
const STORAGE_KEY = 'navGroupOthersOpen';

function readOpen() {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch (_) { return false; }
}

function setOpen(open, remember = true) {
    if (!group) return;
    group.classList.toggle('open', open);
    toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    const icon = toggleBtn.querySelector('i');
    icon.classList.toggle('ri-folder-3-line', !open);
    icon.classList.toggle('ri-folder-open-line', open);
    if (remember) {
        try { localStorage.setItem(STORAGE_KEY, open ? '1' : '0'); } catch (_) {}
    }
}

function containsView(viewId) {
    return !!(group && viewId && group.querySelector(`.nav-item[data-target="${viewId}"]`));
}

// Folder (arbiter) or flat (everyone else).
export function setNavGroupFolded(folded) {
    if (!group) return;
    group.classList.toggle('flat', !folded);
}

// Called by showView. `entered` is true when the view actually changed.
export function syncNavGroup(viewId, entered) {
    if (!group) return;
    const inside = containsView(viewId);
    if (inside && entered && !group.classList.contains('open')) setOpen(true, false);
    toggleBtn.classList.toggle('has-active', inside);
}

export function initNavGroup() {
    if (!group) return;
    setOpen(readOpen(), false);
    toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        setOpen(!group.classList.contains('open'));
    });
}
